/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../graphql-types.gen';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type GetEventsQueryVariables = Exact<{
  pageSize: number;
  currentPage: number;
}>;


export type GetEventsQuery = { events: { total_pages: number, current_page: number, items: Array<{ id: number, title: string, date: string | null | undefined, location: string | null | undefined, image_url: string | null | undefined, short_description: string | null | undefined, long_description: string | null | undefined } | null | undefined> } | null | undefined };

export declare const GetEvents: import("graphql").DocumentNode;
export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetEventsDocument = new TypedDocumentString(`
    query GetEvents($pageSize: Int!, $currentPage: Int!) {
  events(pageSize: $pageSize, currentPage: $currentPage) {
    items {
      id
      title
      date
      location
      image_url
      short_description
      long_description
    }
    total_pages
    current_page
  }
}
    `) as unknown as TypedDocumentString<GetEventsQuery, GetEventsQueryVariables>;